import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import helperMixin from './helpers/mixin'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import VueI18n from 'vue-i18n'
import en from './i18n/en-US.js'
import ru from './i18n/ru-RU.js'
import cookieconsent from 'vue-cookieconsent-component'
import LongTouch from 'vue-long-touch'
import autofillCatch from "@/plugins/autofill-catch.js";
import TestMe from './components/TestMe'
import VueMeta from 'vue-meta'

Vue.directive("autofill-catch", autofillCatch);
Vue.use(LongTouch)
Vue.component('cookie-consent', cookieconsent)
Vue.use(VueI18n)
Vue.use(Vuetify)
Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueMeta)
sync(store, router)

Vue.config.productionTip = false

const messages = {
    en,
    ru
}
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'ru', // set locale
    messages, // set locale messages
})


Vue.component('TestMe', TestMe);

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    mixins: [helperMixin],
    vuetify,
    data: {
        origin: 'https://app.tasko.xyz'
    },
    created() {
        store.dispatch('checkAuth').then(async() => {
            if(store.state.user.token){
                const params = this.$route.params.theme ? this.$route.params : {current: true}
                await store.dispatch('getProfile')
                await Promise.all([
                    store.dispatch('getThemes', params),
                    store.dispatch('getFeeds', this.$route.params)
                ])
                await store.dispatch('setRelavantNoticesByRoute', params)
                await this.loginRedirects()
            }else{
                if (this.$route.path !== "/register") {                    
                    this.$router.push('/login')   
                    // store.commit('OPEN_POPUP', 'Start')  
                }
            }
        })  
    }
})

Notification.requestPermission(function() {

})

// import * as firebase from "firebase";

// const config = {
//       apiKey: "AIzaSyA1-9-TZ-8r3ts4Ubcp9F3dl40L6p9Na0Y",
//       authDomain: "taskmgr-5f9c0.firebaseapp.com",
//       databaseURL: "https://taskmgr-5f9c0.firebaseio.com",
//       projectId: "taskmgr-5f9c0",
//       storageBucket: "taskmgr-5f9c0.appspot.com",
//       messagingSenderId: "520258699405",
//       appId: "1:520258699405:web:0025c0ac5c2d087cf6a2c4",
//       measurementId: "G-2H43SQCFPZ"
//     };
// firebase.initializeApp(config);

// const messaging = firebase.messaging();

// messaging.usePublicVapidKey("BO6JPI2yii2yqWELfjVx9jG3wJha4RqCQ9PGx5ARGzu6P4FVV4AnVVpPHCbjtL8WEuyYCrU8J4OdcvsYKbVTDBo"); // 1. Generate a new key pair

// // Request Permission of Notifications
// messaging.requestPermission().then(() => {
//   console.log('Notification permission granted.');

//   // Get Token
//   messaging.getToken().then((token) => {
//     console.log(token)
//   })
// }).catch((err) => {
//     console.log('Unable to get permission to notify.', err);
// });